import moment from "moment";
import * as util from "@/service/util";
import { ReservationItem } from "@/model/ReservationItem";
import { WorkShubetsuCategory } from "@/model/WorkShubetsuCategory";
import requestService from "@/service/requestService";
import { WorkShubetsu } from "@/model/WorkShubetsu";
import { MESSAGE } from "@/model/Message";
export class ReservationService {
  _reqService: requestService;
  startDate: string;
  constructor() {
    this._reqService = new requestService();
  }
  getDayTabs(startDay: any, rangeDay: number) {
    const day = moment(startDay);
    let arrDay = [];
    const n = (rangeDay * 2)
    for (let i = 0; i <= n; i++) {
      arrDay.push({
        text: day.format("M/D"),
        value: day.format("YYYYMMDD"),
        day: day.day(),
        dayText: day.format("dd"),
        obj: day
      });
      day.add(1, "d");
    }
    return arrDay;
  }

  getDisplayTime(date: string, dateSelected: string) {
    const obj = moment(date, "YYYYMMDD");
    if (date == null || date == "") {
      return { showDate: false };
    } else if (util.formatDate(date, "YYYYMMDD") == dateSelected) {
      return { showDate: false };
    } else {
      return {
        showDate: true,
        date: obj.format("M/D")
      };
    }
  }

  initWorkVariables(workTypeCategoryLength: number) {
    let workCounts = [];
    let reserveByCategory: ReservationItem[][] = [];
    for (let i = 0; i < workTypeCategoryLength; i++) {
      workCounts.push(0);
      reserveByCategory.push([]);
    }
    return { workCounts, reserveByCategory };
  }

  filterReserveList(
    reserveListAll: any,
    workTypeCategories: WorkShubetsuCategory[],
    filterKey: string,
    filterValue: string
  ) {
    let arrWorkCounts: number[][] = [];
    let arrReserveByCategory: any = [];

    reserveListAll.forEach((listDay: ReservationItem[]) => {
      let { workCounts, reserveByCategory } = this.initWorkVariables(
        workTypeCategories.length
      );
      const list = Array.from(listDay);
      let listFilter;
      if (filterKey && filterValue) {
        listFilter = list.filter(
          (item: any) =>
            item[filterKey] && item[filterKey].indexOf(filterValue) > -1
        );
      } else {
        listFilter = list;
      }
      //sort
      listFilter.sort(this.compareReservation);

      const listNotCancel = listFilter.filter(
        (item: any) => item.progressKbn != "3"
      );
      workCounts[0] = listNotCancel.length;
      reserveByCategory[0] = Array.from(listFilter);
      const _workTypeCategories = workTypeCategories.slice(
        1,
        workTypeCategories.length
      ); //remove category all
      listFilter.forEach((item: ReservationItem) => {
        const index = _workTypeCategories.findIndex(
          (work: WorkShubetsuCategory) =>
            item.workShubetsuCategoryId ==
            work.workShubetsuCategoryId.toString()
        );
        if (index > -1) {
          if (item.progressKbn != "3") {
            workCounts[index + 1]++;
          }
          reserveByCategory[index + 1].push(item);
        }
      });
      arrWorkCounts.push(workCounts);
      arrReserveByCategory.push(reserveByCategory);
    });

    return { arrWorkCounts, arrReserveByCategory };
  }

  getWorkShubetsuCategories() {
    let promise1 = new Promise((resolve, reject) => {
      this._reqService.getWorkShubetsuCategories().then(
        (res: any) => {
          let workTypeCategories = Array.from(res);
          let all: WorkShubetsuCategory = {
            workShubetsuCategoryId: 0,
            workShubetsuCategoryTitle: "全件"
          };
          workTypeCategories.splice(0, 0, all);
          resolve(workTypeCategories);
        },
        (error: any) => {
          resolve([]);
        }
      );
    });
    return promise1;
  }

  requestData(fromDay: any, categoryLength: number, rangeDay: number) {
    this.startDate = fromDay.format("YYYYMMDD");
    this.initWorkVariables(categoryLength);
    let promise1 = new Promise((resolve, reject) => {
      let arrDay = this.getDayTabs(fromDay, rangeDay);
      let formatDate = arrDay[0].value;
      let toDate = arrDay[arrDay.length - 1].value;
      this._reqService.getReservationList(formatDate, toDate).then(
        (res: any) => {
          if (this.startDate != arrDay[0].value) {
            reject(null);
          } else {
            let reserveListAll = res;
            let arrRes: any = [];
            if (reserveListAll) {
              arrDay.forEach((day: any) => {
                if (reserveListAll[day.value]) {
                  let obj = reserveListAll[day.value].map((item: any) => {
                    const nyuuko = this.getDisplayTime(
                      item.nyuukoPlansYmd,
                      day.value
                    );
                    const shukko = this.getDisplayTime(
                      item.shukkoPlansYmd,
                      day.value
                    );
                    return Object.assign(item, {
                      showNyuukoYmd: nyuuko.showDate,
                      nyuukoYmd: nyuuko.date,
                      showShukkoYmd: shukko.showDate,
                      shukkoYmd: shukko.date
                    });
                  });
                  arrRes.push(obj);
                } else {
                  arrRes.push([]);
                }
              });
              resolve(arrRes);
            } else {
              resolve([]);
            }
          }
        },
        (error: any) => {
          reject(error);
        }
      );
    });
    return promise1;
  }

  isHasDaisha(daisha: any) {
    return daisha != null && Object.keys(daisha).length > 0;
  }

  saveWorkShubetsu(works: WorkShubetsu[]) {
    const worksChanged = works.filter((work: WorkShubetsu) => work.changed);
    let promise1 = new Promise((resolve, reject) => {
      if (worksChanged.length > 0) {
        const mapWorks = worksChanged.map((work: WorkShubetsu) => {
          return {
            workShubetsuCd: work.workShubetsuCd,
            workShubetsuNm: work.workShubetsuNm,
            workShubetsuCategoryId: work.workShubetsuCategoryId,
            isSelected: work.isSelected
          };
        });
        this._reqService.saveWorkShubetsu(mapWorks).then(
          (res: any) => {
            resolve(MESSAGE.SaveWorkShubetsu);
          },
          (error: any) => {
            reject(error);
          }
        );
      } else {
        resolve(MESSAGE.SaveNoChangeWorkShubetsu);
      }
    });
    return promise1;
  }

  getWorkCountsPerDay(arrWorkCounts: any, workCateIndex: number) {
    let counts: number[] = [];
    arrWorkCounts.forEach((items: any) => {
      counts.push(items[workCateIndex]);
    });

    return counts;
  }

  //sort workprogress 14 (complete) to below
  compareReservation(a: ReservationItem, b: ReservationItem) {
    // キャンセル(progressKbn 3) > 納車(progressKbn 2) > 車検済 (sknWorkProgressState 14)
    const progressKbn1 = a.progressKbn ? +a.progressKbn : 0;
    const progressKbn2 = b.progressKbn ? +b.progressKbn : 0;

    let c = 0, n = 0, w = 0;
    if (progressKbn2 == 3 && progressKbn1 != 3) {
      c = -1;
    }
    if (progressKbn1 == 3 && progressKbn2 != 3) {
      c = 1;
    }
    if (progressKbn2 == 2 && progressKbn1 != 2) {
      n = -1;
    }
    if (progressKbn1 == 2 && progressKbn2 != 2) {
      n = 1;
    }
    if (b.sknWorkProgressState == 14 && a.sknWorkProgressState != 14) {
      w = -1;
    }
    if (a.sknWorkProgressState == 14 && b.sknWorkProgressState != 14) {
      w = 1;
    }

    return c || n || w;
  }
}
